/* @flow */

import React from 'react';
import UploadItemState from './UploadItemState';

type Props = {
  upload: RunningUpload,
};

const styles = {
  p: {
    overflow: 'hidden',
  },
};

const UploadItem = ({ upload }: Props) => (
  <div className="ui clearing segment">
    <p style={styles.p}>{upload.name}</p>
    <UploadItemState upload={upload} />
  </div>
);

export default UploadItem;



// WEBPACK FOOTER //
// ./src/modules/bucket/screens/Upload/components/UploadItem.js